// src/composables/reports/useVentasCategoriaQuery.ts
import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref } from "vue";
import { getVentasPorCategoriaAction } from "../actions";

export function useVentasCategoriaQuery(
  fechaInicio?: Ref<string>,
  fechaFin?: Ref<string>
) {
  const query = useQuery({
    queryKey: computed(() => [
      "ventas-categoria",
      fechaInicio?.value ?? "",
      fechaFin?.value ?? "",
    ]),
    queryFn: async () => {
      const response = await getVentasPorCategoriaAction(
        fechaInicio?.value,
        fechaFin?.value
      );
      return response.data;
    },
    staleTime: 60000,
    placeholderData: (previousData) => previousData
  });

  const ventasCategoriaData = computed(() => query.data.value);
  return {
    ventasCategoriaData,
    ...query,
  };
}
